import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {API, UserInitiatePayload, UserInitiateResponse} from '@chekin/api';
import {FastAPIServiceError} from '@chekin/core';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type Props = Omit<
  UseMutationOptions<UserInitiateResponse, FastAPIServiceError, UserInitiatePayload>,
  'mutationFn'
>;
function useInitUserAccountMutation({onError, ...options}: Props = {}) {
  const isMounted = useIsMounted();

  return useMutation<UserInitiateResponse, FastAPIServiceError, UserInitiatePayload>({
    mutationFn: payload => API.auth.initiateUser(payload),
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    ...options,
  });
}

export {useInitUserAccountMutation};
